import React from "react";
import {
  Document,
  Page,
  View,
  Text,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";

// Font registration
Font.register({
  family: "Roboto",
  fonts: [
    {
      src: "https://cdn.jsdelivr.net/npm/@fontsource/roboto/files/roboto-latin-400-normal.woff",
      fontWeight: "normal",
    },
    {
      src: "https://cdn.jsdelivr.net/npm/@fontsource/roboto/files/roboto-latin-700-normal.woff",
      fontWeight: "bold",
    },
  ],
});

Font.registerHyphenationCallback(word => [word]);

// Styles
const styles = StyleSheet.create({
  page: {
    padding: 25,
    fontFamily: "Roboto",
    position: "relative",
    paddingTop: 110,
    paddingBottom: 90,
  },
  logo2: {
    position: "absolute",
    top: 30,
    left: 30,
    width: 60,
  },
  upperDesign: {
    position: "absolute",
    top: -10,
    right: 0,
    width: 280,
  },
  lowerDesign: {
    position: "absolute",
    bottom: -10,
    right: 0,
    width: 300,
  },
  mainContent: {
    flex: 1,
    alignContent: "center",
    marginTop: 10,
    paddingHorizontal: 40,
  },
  heading: {
    fontSize: 26,
    fontWeight: "bold",
    marginBottom: 20,
    textAlign: "left",
  },
  paragraph: {
    fontSize: 18,
    marginBottom: 40,
    lineHeight: 1.4,
    maxWidth: 480,
  },
  pageNumber_Box: {
    position: "absolute",
    bottom: 20,
    left: 10,
    width: 25,
    height: 25,
    border: "2px solid orange",
    borderRadius: 15,
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    zIndex: 2,
    
  },
  pageNumber: {
    fontSize: 11,
    color: "#000",
    textAlign: "center",
  },
});

// PDF SummaryPage Component
const SummaryPagePDF = ({ assets, showPageNumber }) => (
  <Page size="A4" style={styles.page}>
    {/* Decorative elements */}
    <Image src={assets.upper} style={styles.upperDesign} fixed />
    <Image src={assets.lower} style={styles.lowerDesign} fixed />
    <Image src={assets.logo2} style={styles.logo2} fixed />

    {/* Main content */}
    <View style={styles.mainContent}>
      <Text style={styles.heading}>WHAT’S NEXT?</Text>
      <Text style={styles.paragraph}>
        Ready to take the next step? Connect with our career coaches today for
        further handholding support and growth. Let's find your True North
        together and make your career aspirations a reality!
      </Text>
    </View>

    {/* Footer - page number only */}
    <>
      {showPageNumber && (
        <View style={styles.pageNumber_Box} fixed>
          <Text
            style={styles.pageNumber}
            render={({ pageNumber, totalPages }) => `${pageNumber}`}
            fixed
          />
        </View>
      )}
    </>
  </Page>
);

export default SummaryPagePDF;
